module.exports = global["jQuery"] = require("-!/tmp/build_8c5da19e/node_modules/expose-loader/index.js?$!./jquery.js");